// 部品 標準ボタン
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { isBrouserEdge, isBrowserIe } from '../BrowserJudgment';
var row_class_name = '';
var DefaultButton = function (_a) {
    var label = _a.label, strong = _a.strong, color = _a.color, handleClick = _a.handleClick, className = _a.className, disabled = _a.disabled, show = _a.show;
    // 太字
    var str = strong ? React.createElement("strong", null, label) : React.createElement(React.Fragment, null, label);
    // 色の規定値
    if (typeof color === 'undefined') {
        color = 'main-color';
    }
    // ClassNameの規定値（空文字）
    if (typeof className === 'undefined') {
        className = '';
    }
    // disabledの規定値
    if (typeof disabled === 'undefined') {
        disabled = false;
    }
    // showの規定値
    if (typeof show === 'undefined') {
        show = true;
    }
    if (show === true) {
        if (isBrowserIe()) {
            // IE
            row_class_name = 'ie-grid';
        }
        else if (isBrouserEdge()) {
            row_class_name = 'edge-grid';
        }
        else {
            // その他のブラウザ
            row_class_name = 'no-ie-grid';
        }
    }
    else {
        row_class_name = 'no-grid';
    }
    return (React.createElement(Row, { className: "row-right-button " + row_class_name },
        React.createElement(Col, { className: "text-right" },
            React.createElement("a", { className: "btn btn-xl btn-" + color + " " + className, onClick: handleClick }, str))));
};
export default DefaultButton;
